export default "/images/vendor/flag-icon-css/flags/4x3/lv.svg?9a5d132cec13c3e033f02e906883f06b";